import React from 'react';

import Footer from '../../components/Footer';

export default function Error404() {
    return(
        <>
            <main className='h-screen'>
                <h1 className='text-lg font-bold'>Error 404 - Pagina no encontrada</h1>
            </main>
            <Footer />
        </>
    )
}
